import React, { useState } from 'react';

// Types
import { QuestionType } from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useQuestion } from './use-question';

// Components
import { WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpToggleSwitch } from 'Wpds/components/toggle-switch';
import { WpCollapsible } from 'Wpds/components/collapsible';

type Props = {
  question: QuestionType;
  onChange: Function;
};

const QuestionExplanation = ({ question, onChange }: Props) => {
  const { handleUpdateQuestion } = useQuestion({ question, onChange });

  const [checked, setChecked] = useState(question.showExplanation);
  const [description, setDescription] = useState(question.explanationDescription);

  const handleSetChecked = value => {
    setChecked(value);
    handleUpdateQuestion({ showExplanation: value });
  };

  const handleSetDescription = value => {
    setDescription(value);
    handleUpdateQuestion({ explanationDescription: value });
  };

  return (
    <WpFormLayout direction="vertical">
      <WpToggleSwitch
        id={`expanation_toggle_${question.key}`}
        label="Include reasoning"
        checked={checked}
        onChange={handleSetChecked}
      />
      <WpCollapsible open={checked}>
        <WpFormLayout direction="vertical" spacing="sm">
          <WpTextField
            id={`explanation_${question.key}`}
            name="explanation"
            label="Question"
            placeholder="Summarize why you gave that answer"
            value={description}
            onChange={handleSetDescription}
            required
          />
          <WpTextField
            id={`explanation_${question.key}`}
            name="explanation"
            label="Question"
            value="User will be provided with text area to input written response"
            multiline={2}
            labelHidden
            disabled
          />
        </WpFormLayout>
      </WpCollapsible>
    </WpFormLayout>
  );
};

export default QuestionExplanation;
